import React, { useEffect, useState } from "react";
import Preloader from "../../Components/Preloader";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import { NavLink } from "react-router-dom";
import Home_Seo from "../../SEO/Home_Seo";
import AOS from "aos";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

function Home() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate an asynchronous operation (e.g., fetching data)
    setTimeout(() => {
      setIsLoading(false);
    }, 500); // Simulating a 1-second delay
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 3000,
      easing: "ease-in-out",
      once: true,
      mirror: false,
    });
  }, []);

  return (
    <div>
      {isLoading ? (
        <Preloader />
      ) : (
        <>
          <Home_Seo />
          <div className="page-wrapper">
            <Header />
            {/* Hero Section Start */}
            <section className="hero-wrap style1 bg-selago">
              <div className="hero-content-wrap">
                <div className="hero-content">
                  <span data-aos="fade-up" data-aos-duration={1000}>
                    Simple. Quick. Secure.
                  </span>
                  <h1
                    data-aos="fade-up"
                    data-aos-duration={1000}
                    data-aos-delay={500}
                  >
                    Transfer Money in Minutes
                  </h1>
                  <p
                    data-aos="fade-up"
                    data-aos-duration={1000}
                    data-aos-delay={800}
                  >
                    The fastest and cheapest way to Transfer Money to Nigeria.
                    Sign up today.
                  </p>
                  <div
                    className="hero-btn"
                    data-aos="fade-up"
                    data-aos-duration={1000}
                    data-aos-delay={1200}
                  >
                    <NavLink to="https://play.google.com/store/apps/details?id=com.remit.FinestPayMoney" target="_blank">
                      <img src="assets/img/android.png" />
                    </NavLink>
                    &nbsp;
                    <NavLink to="https://apps.apple.com/app/finestpay/id6739626344" target="_blank">
                      <img src="assets/img/apple.png" />
                    </NavLink>
                  </div>
                </div>
                <div className="hero-img-wrap lg-none">
                  <img
                    className="hero-img"
                    src="assets/img/hero/hero-img-3.png"
                    alt="Image"
                  />
                  <div className="hero-chart-box-1">
                    <h5>Send Money to Nigeria</h5>
                    <img src="assets/img/hero/nigeria.png" alt="Image" />
                  </div>
                </div>
              </div>
            </section>
            {/* Hero Section End */}
            {/* Feature Section Start */}
            <section className="feature-wrap pt-100 pb-75">
              <div className="container">
                <div className="section-title style1 text-center mb-40">
                  <span>Our Features</span>
                  <h2>Why Choose Us?</h2>
                </div>
                <div className="feature-card-wrap">
                  <div className="feature-card">
                    <div className="feature-icon">
                      <i className="flaticon-star-2" />
                    </div>
                    <div className="feature-text">
                      <h4 className="feature-title">
                        <NavLink to="#">Quick Transfer</NavLink>
                      </h4>
                      <p>
                        We prioritise speed, ensuring your money reaches its
                        destination in minutes, not days.
                      </p>
                    </div>
                  </div>
                  <div className="feature-card">
                    <div className="feature-icon">
                      <i className="flaticon-star-2" />
                    </div>
                    <div className="feature-text">
                      <h4 className="feature-title">
                        <NavLink to="#">Low Cost</NavLink>
                      </h4>
                      <p>
                        Enjoy competitive rates and low transfer fees,
                        maximising the amount your loved ones receive.
                      </p>
                    </div>
                  </div>
                  <div className="feature-card">
                    <div className="feature-icon">
                      <i className="flaticon-star-2" />
                    </div>
                    <div className="feature-text">
                      <h4 className="feature-title">
                        <NavLink to="#">Safe And Secure</NavLink>
                      </h4>
                      <p>
                        Your security is our top priority. We use advanced
                        encryption technology to protect your personal and
                        financial information.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            {/* Feature Section End */}           

            {/* Steps Section start */}
            <section className="why-choose-wrap style3 ptb-100 bg-f bg-1">
              <div className="container">
                <div className="row gx-5 align-items-center">
                  <div className="col-lg-6">
                    <div className="why-choose-content">
                      <div className="content-title style1 mb-40">
                        <span>How it Works?</span>
                        <h2>Send Money In 4 Easy Steps</h2>
                        <p>
                          Registering and sending money with FinestPay has
                          become simple.
                        </p>
                      </div>
                      <div className="wh-item-wrap style2">
                        <div className="wh-item">
                          <div className="wh-icon">
                            <span>1</span>
                          </div>
                          <div className="wh-text">
                            <h5>
                              <NavLink to="#">Register With Us</NavLink>
                            </h5>
                            <p>
                              Fill in our easy to navigate and self-explantory
                              registration form on web or app.
                            </p>
                          </div>
                        </div>
                        <div className="wh-item">
                          <div className="wh-icon">
                            <span>2</span>
                          </div>
                          <div className="wh-text">
                            <h5>
                              <NavLink to="#">Add Beneficiary</NavLink>
                            </h5>
                            <p>
                              Who you want the money to receive? Add as many
                              beneficiaries you want to.
                            </p>
                          </div>
                        </div>
                        <div className="wh-item">
                          <div className="wh-icon">
                            <span>3</span>
                          </div>
                          <div className="wh-text">
                            <h5>
                              <NavLink to="#">Initiate Transfer</NavLink>
                            </h5>
                            <p>
                              Select beneficiary, enter amount you want to send,
                              Pay for your transfer and we do the rest.
                            </p>
                          </div>
                        </div>
                        <div className="wh-item">
                          <div className="wh-icon">
                            <span>4</span>
                          </div>
                          <div className="wh-text">
                            <h5>
                              <NavLink to="#">Payout</NavLink>
                            </h5>
                            <p>
                              We fulfill your Money Transfer order and payout to
                              your beneficiary in your preferred mode of
                              collection.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="wh-img bg-f wh-bg-4">
                      <div className="tr-text-wrap"></div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            {/* Steps Section End */}
            {/* Mobile app Section Start */}
            <section className="about-wrap style1 ptb-100">
              <div className="container">
                <div className="row gx-5 align-items-center">
                  <div className="col-lg-6">
                    <div className="about-img-wrap">
                      <div className="about-img-one">
                        <div className="about-img-text moveHorizontal">
                          <NavLink to="https://play.google.com/store/apps/details?id=com.remit.FinestPayMoney" target="_blank">
                            <img src="assets/img/android.png" />
                          </NavLink>
                        </div>
                        <div className="about-img bg-f about-bg-2" />
                      </div>
                      <div className="about-img-two ">
                        <div
                          className="about-img bg-f about-bg-1"
                          style={{ backgroundColor: "transparent" }}
                        />
                        <div className="about-img-text moveHorizontal_reverse">
                          <NavLink to="https://apps.apple.com/app/finestpay/id6739626344" target="_blank">
                            <img src="assets/img/apple.png" />
                          </NavLink>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="about-content">
                      <div className="content-title style1">
                        <span>Download App</span>
                        <h2>
                          We Have Created A Bespoke Money Transfer Service For
                          Our Customers.
                        </h2>
                        <p>
                          FinestPay is your one stop shop for money transfer
                          from United Kingdom to the rest of the world. We are
                          positioned to get your money to the people you care
                          about quickly, securely and at low-cost ensuring
                          complete peace of mind.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            {/* Mobile app Section End */}
            {/* Testimonial Section start */}
            <section className="testimonial-wrap style1 ptb-100">
              <div className="container">
                <div className="section-title style1 text-center mb-40">
                  <span>Testimonials</span>
                  <h2>What People Say About Us</h2>
                </div>
              </div>
              <Swiper
                loop={true}
                spaceBetween={0}
                autoplay={{
                  delay: 4500,
                  disableOnInteraction: false,
                }}
                speed={1500}
                centeredSlides={true}
                roundLengths={true}
                pagination={{
                  el: ".testimonial-pagination",
                  clickable: true,
                  bulletClass: "swiper-pagination-bullet",
                  bulletActiveClass: "swiper-pagination-bullet-active",
                }}
                breakpoints={{
                  0: { slidesPerView: 1 },
                  768: { slidesPerView: 1 },
                  992: { slidesPerView: 2 },
                  1200: { slidesPerView: 2 },
                  1400: { slidesPerView: 2 },
                  1920: { slidesPerView: 2 },
                }}
                modules={[Pagination, Autoplay]}
                className="testimonial-slider-two"
              >
                <SwiperSlide>
                  <div className="testimonial-item">
                    <div className="client-info-wrap">
                      <div className="client-img">
                        <img
                          src="assets/img/testimonials/bukola-coker.jpg"
                          alt="Bukola Coker"
                        />
                      </div>
                      <div className="client-info">
                        <h5>Bukola Coker</h5>
                        <span>Tala Harmony Inc.</span>
                      </div>
                    </div>
                    <div className="client-quote">
                      <p>
                        FinestPay successfully transferred funds to our African
                        recipients within minutes. They were literal lifesavers
                        on this occasion.
                      </p>
                    </div>
                    <div className="testimonial-footer">
                      <div className="quote-icon">
                        <i className="flaticon-quotation" />
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="testimonial-item">
                    <div className="client-info-wrap">
                      <div className="client-img">
                        <img
                          src="assets/img/testimonials/charles-nwaodu.jpg"
                          alt="Charles Nwaodu"
                        />
                      </div>
                      <div className="client-info">
                        <h5>Charles Nwaodu</h5>
                        <span>CN-Investments Ltd.</span>
                      </div>
                    </div>
                    <div className="client-quote">
                      <p>
                        The difference between the cost of foreign currency from
                        the banks and from FinestPay is unbelievable. FinestPay
                        saved me and my business money and time, again and
                        again.
                      </p>
                    </div>
                    <div className="testimonial-footer">
                      <div className="quote-icon">
                        <i className="flaticon-quotation" />
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="testimonial-item">
                    <div className="client-info-wrap">
                      <div className="client-img">
                        <img
                          src="assets/img/testimonials/ngozi-eze.png"
                          alt="Ngozi Eze"
                        />
                      </div>
                      <div className="client-info">
                        <h5>Ngozi Eze</h5>
                        <span>Yandel Ng.</span>
                      </div>
                    </div>
                    <div className="client-quote">
                      <p>
                        I have used FinestPay on many occasions for funds
                        transfer. I cannot speak highly enough of the service I
                        received - courteous, professional, and stress-free
                        service from FinestPay. The exchange rate has always
                        been very good. I recommend FinestPay to my business
                        associates and look forward to doing more business in
                        the future.
                      </p>
                    </div>
                    <div className="testimonial-footer">
                      <div className="quote-icon">
                        <i className="flaticon-quotation" />
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>
              <div className="testimonial-pagination slider-pagination style1 swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal"></div>
            </section>
            {/* Testimonial Section End */}
            {/* Footer Section Here */}
            <Footer />
          </div>
        </>
      )}
    </div>
  );
}

export default Home;
